import { render } from "./recap.vue?vue&type=template&id=c1424d48"
import script from "./recap.vue?vue&type=script&lang=js"
export * from "./recap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__